import type { IComponentHandler, IComponentHandlerCallbacks, IInsertData } from "../Header.ts";

/**
 * Base class for component handler with a few default implementations. The
 * following methods must be overridden:
 * - getInputElement
 * - insertText
 */
export abstract class AbstractComponentHandler implements IComponentHandler {
  accepts(_$element: JQuery): boolean {
    return false;
  }

  focus(_$element: JQuery): void {
    // no-op by default
  }

  initialize(_$element: JQuery, _callbacks: IComponentHandlerCallbacks): boolean {
    return true;
  }

  abstract getInputElement($element: JQuery): JQuery;

  abstract insertText($element: JQuery, data: IInsertData): void;
}
